// // DashboardContent.jsx
// import React, { useEffect } from "react";
// import Emails from "./Emails";
// import Meetings from "./Meetings";
// import TodoList from "./TodoList";
// import Accounts from "./Accounts";
// import { useEmails } from "../../providers/EmailsContext";
// import { ErrorBoundary } from "./ErrorBoundary";
// import { useAuth } from "../../providers/AuthContext";

// const UpcomingEventCard = ({ nextMeeting, loadingMeeting }) => {
//   // Format meeting time in 12-hour format with AM/PM
//   const formatMeetingTime = (dateTime) => {
//     if (!dateTime) return "";
//     try {
//       const date = new Date(dateTime);
//       if (isNaN(date.getTime())) return "";
//       return date.toLocaleTimeString("en-US", {
//         hour: "numeric",
//         minute: "2-digit",
//       });
//     } catch (err) {
//       console.error("Error formatting meeting time:", err);
//       return "";
//     }
//   };

//   // Helper function to extract the meeting link
//   const getMeetingLink = (meeting) => {
//     if (!meeting) return null;

//     // Check for conferenceData with entryPoints (Google Meet standard format)
//     if (
//       meeting.conferenceData &&
//       Array.isArray(meeting.conferenceData.entryPoints)
//     ) {
//       // Find video entry point
//       const videoEntry = meeting.conferenceData.entryPoints.find(
//         (entry) => entry.entryPointType === "video"
//       );
//       if (videoEntry && videoEntry.uri) {
//         return videoEntry.uri;
//       }

//       // If no video entry found, use the first entry point
//       if (
//         meeting.conferenceData.entryPoints.length > 0 &&
//         meeting.conferenceData.entryPoints[0].uri
//       ) {
//         return meeting.conferenceData.entryPoints[0].uri;
//       }
//     }

//     // Check for conferenceData with direct link property
//     if (meeting.conferenceData && meeting.conferenceData.link) {
//       return meeting.conferenceData.link;
//     }

//     // Check for any URI in the conferenceData object
//     if (meeting.conferenceData && meeting.conferenceData.uri) {
//       return meeting.conferenceData.uri;
//     }

//     // Check if there's a location that looks like a URL (Zoom, Teams, etc.)
//     if (meeting.location) {
//       const locationStr = meeting.location.toLowerCase();
//       if (
//         locationStr.includes("http") ||
//         locationStr.includes("zoom") ||
//         locationStr.includes("teams") ||
//         locationStr.includes("meet.google")
//       ) {
//         // Try to extract URL from location
//         const urlMatch = meeting.location.match(/(https?:\/\/[^\s]+)/g);
//         if (urlMatch && urlMatch[0]) {
//           return urlMatch[0];
//         }
//         return meeting.location;
//       }
//     }

//     // No meeting link found
//     return null;
//   };

//   const meetingLink = nextMeeting ? getMeetingLink(nextMeeting) : null;

//   return (
//     // <div className="relative bg-[#001D47] m-auto p-4 mb-2 w-[96%] rounded-md">
//     //   <div className="absolute bg-gradient-to-r from-[#00419E] to-[#001D47] w-[170px] h-[170px] bottom-[-20%] right-[-2%] z-1 rounded-full"></div>
//     //   <div className="p-2 flex items-center">
//     //     <div className="text-white font-bold text-xl flex-grow">
//     //       Upcoming Events
//     //     </div>
//     //   </div>

//     //   {loadingMeeting ? (
//     //     <div className="p-2 text-white text-xs flex items-center justify-center h-16">
//     //       <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white"></div>
//     //     </div>
//     //   ) : nextMeeting ? (
//     //     <div className="px-2">
//     //       <div className="text-white text-lg font-medium mb-2">
//     //         {nextMeeting.summary || "Untitled Meeting"}
//     //       </div>

//     //       {nextMeeting.location && (
//     //         <div className="text-white text-sm mb-2">
//     //           <span className="opacity-80">Location:</span>{" "}
//     //           {nextMeeting.location}
//     //         </div>
//     //       )}

//     //       {nextMeeting.attendees && nextMeeting.attendees.length > 0 && (
//     //         <div className="text-white text-sm mb-2">
//     //           <span className="opacity-80">Attendees:</span>{" "}
//     //           {nextMeeting.attendees.length}
//     //         </div>
//     //       )}

//     //       <div className="flex items-center justify-between mt-4">
//     //         <div className="text-white font-semibold flex items-center">
//     //           <svg
//     //             className="h-5 w-5 mr-2 opacity-80"
//     //             fill="none"
//     //             viewBox="0 0 24 24"
//     //             stroke="currentColor"
//     //           >
//     //             <path
//     //               strokeLinecap="round"
//     //               strokeLinejoin="round"
//     //               strokeWidth={1.5}
//     //               d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//     //             />
//     //           </svg>
//     //           {nextMeeting.start && nextMeeting.end
//     //             ? `${formatMeetingTime(
//     //                 nextMeeting.start.dateTime || nextMeeting.start.date
//     //               )} to ${formatMeetingTime(
//     //                 nextMeeting.end.dateTime || nextMeeting.end.date
//     //               )}`
//     //             : "Time not specified"}
//     //         </div>
//     //         <div className="flex items-center">
//     //           {meetingLink ? (
//     //             <a
//     //               href={meetingLink}
//     //               target="_blank"
//     //               rel="noopener noreferrer"
//     //               className="py-2 px-4 text-blue-600 bg-white font-medium rounded-md border-0 inline-flex items-center hover:bg-opacity-90 hover:shadow-md transition-all duration-200"
//     //             >
//     //               <svg
//     //                 className="h-4 w-4 mr-2"
//     //                 fill="none"
//     //                 viewBox="0 0 24 24"
//     //                 stroke="currentColor"
//     //               >
//     //                 <path
//     //                   strokeLinecap="round"
//     //                   strokeLinejoin="round"
//     //                   strokeWidth={2}
//     //                   d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
//     //                 />
//     //               </svg>
//     //               Join Meeting
//     //             </a>
//     //           ) : (
//     //             <div className="py-2 px-4 text-blue-300 bg-white bg-opacity-50 font-medium rounded-md border-0 inline-flex items-center cursor-not-allowed">
//     //               <svg
//     //                 className="h-4 w-4 mr-2"
//     //                 fill="none"
//     //                 viewBox="0 0 24 24"
//     //                 stroke="currentColor"
//     //               >
//     //                 <path
//     //                   strokeLinecap="round"
//     //                   strokeLinejoin="round"
//     //                   strokeWidth={2}
//     //                   d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
//     //                 />
//     //               </svg>
//     //               No Link Available
//     //             </div>
//     //           )}
//     //         </div>
//     //       </div>
//     //     </div>
//     //   ) : (
//     //     <div className="flex flex-col items-center justify-center py-2 text-white">
//     //       <svg
//     //         className="h-12 w-12 mb-3 opacity-80"
//     //         fill="none"
//     //         viewBox="0 0 24 24"
//     //         stroke="currentColor"
//     //       >
//     //         <path
//     //           strokeLinecap="round"
//     //           strokeLinejoin="round"
//     //           strokeWidth={1.5}
//     //           d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
//     //         />
//     //       </svg>
//     //       <p className="text-lg font-medium">No upcoming meetings</p>
//     //       <p className="text-sm opacity-80 mt-1">
//     //         Your schedule is clear for today
//     //       </p>
//     //     </div>
//     //   )}
//     // </div>
//     <div className="relative bg-[#001D47] m-auto p-4 mb-2 w-[96%] rounded-md overflow-hidden min-h-[200px]">
//       <div className="absolute bg-gradient-to-r from-[#00419E] to-[#001D47] w-[170px] h-[170px] bottom-[-20%] right-[-2%] z-0 rounded-full"></div>

//       {/* Content wrapper with relative positioning and higher z-index */}
//       <div className="relative z-10">
//         <div className="p-2 flex items-center">
//           <div className="text-white font-bold text-xl flex-grow">
//             Upcoming Events
//           </div>
//         </div>

//         {loadingMeeting ? (
//           <div className="p-2 text-white text-xs flex items-center justify-center h-16">
//             <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white"></div>
//           </div>
//         ) : nextMeeting ? (
//           <div className="px-2">
//             <div className="text-white text-lg font-medium mb-2">
//               {nextMeeting.summary || "Untitled Meeting"}
//             </div>

//             {nextMeeting.location && (
//               <div className="text-white text-sm mb-2">
//                 <span className="opacity-80">Location:</span>{" "}
//                 {nextMeeting.location}
//               </div>
//             )}

//             {nextMeeting.attendees && nextMeeting.attendees.length > 0 && (
//               <div className="text-white text-sm mb-2">
//                 <span className="opacity-80">Attendees:</span>{" "}
//                 {nextMeeting.attendees.length}
//               </div>
//             )}

//             <div className="flex items-center justify-between mt-4">
//               <div className="text-white font-semibold flex items-center">
//                 <svg
//                   className="h-5 w-5 mr-2 opacity-80"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={1.5}
//                     d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                   />
//                 </svg>
//                 {nextMeeting.start && nextMeeting.end
//                   ? `${formatMeetingTime(
//                       nextMeeting.start.dateTime || nextMeeting.start.date
//                     )} to ${formatMeetingTime(
//                       nextMeeting.end.dateTime || nextMeeting.end.date
//                     )}`
//                   : "Time not specified"}
//               </div>
//               <div className="flex items-center">
//                 {meetingLink ? (
//                   <a
//                     href={meetingLink}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="py-2 px-4 text-blue-600 bg-white font-medium rounded-md border-0 inline-flex items-center hover:bg-opacity-90 hover:shadow-md transition-all duration-200"
//                   >
//                     <svg
//                       className="h-4 w-4 mr-2"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
//                       />
//                     </svg>
//                     Join Meeting
//                   </a>
//                 ) : (
//                   <div className="py-2 px-4 text-blue-300 bg-white bg-opacity-50 font-medium rounded-md border-0 inline-flex items-center cursor-not-allowed">
//                     <svg
//                       className="h-4 w-4 mr-2"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
//                       />
//                     </svg>
//                     No Link Available
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         ) : (
//           <div className="flex flex-col items-center justify-center py-2 text-white">
//             <svg
//               className="h-12 w-12 mb-3 opacity-80"
//               fill="none"
//               viewBox="0 0 24 24"
//               stroke="currentColor"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth={1.5}
//                 d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
//               />
//             </svg>
//             <p className="text-lg font-medium">No upcoming meetings</p>
//             <p className="text-sm opacity-80 mt-1">
//               Your schedule is clear for today
//             </p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// const DashboardContent = ({ onEmailSelect, configModalClosed }) => {
//   const [nextMeeting, setNextMeeting] = React.useState(null);
//   const [loadingMeeting, setLoadingMeeting] = React.useState(false);
//   const {
//     emails,
//     loading,
//     error,
//     activeCategory,
//     currentPage,
//     setCurrentPage,
//     viewingAllAccounts,
//     fetchEmails,
//     handleCategoryChange,
//     deleteEmail,
//     emailsPerPage,
//     progress,
//   } = useEmails();

//   console.log("The emails are ", emails);

//   const { fetchUserData } = useAuth();

//   React.useEffect(() => {
//     const handleMeetingsUpdate = (event) => {
//       if (event.detail && Array.isArray(event.detail.meetings)) {
//         const meetings = event.detail.meetings;

//         if (meetings.length > 0) {
//           const now = new Date();
//           const upcomingMeetings = meetings
//             .filter((meeting) => {
//               if (!meeting.start?.dateTime) return false;
//               return new Date(meeting.start.dateTime) > now;
//             })
//             .sort((a, b) => {
//               const aTime = a.start?.dateTime || "";
//               const bTime = b.start?.dateTime || "";
//               return new Date(aTime) - new Date(bTime);
//             });

//           if (upcomingMeetings.length > 0) {
//             setNextMeeting(upcomingMeetings[0]);
//           } else {
//             setNextMeeting(null);
//           }
//         } else {
//           setNextMeeting(null);
//         }
//       }
//     };

//     // Add event listener for meetings updates
//     window.addEventListener("meetings_updated", handleMeetingsUpdate);

//     return () => {
//       window.removeEventListener("meetings_updated", handleMeetingsUpdate);
//     };
//   }, []);

//   useEffect(() => {
//     fetchUserData();
//   }, []);

//   React.useEffect(() => {
//     const cachedEmails = localStorage.getItem("cached_emails");
//     if (!cachedEmails) {
//       fetchEmails(1, "all", true);
//     }
//   }, []);

//   return (
//     <div className="p-4 sm:p-6 flex flex-col h-full overflow-y-auto">
//       {/* Upcoming Events Card */}
//       <UpcomingEventCard
//         nextMeeting={nextMeeting}
//         loadingMeeting={loadingMeeting}
//       />

//       {/* Accounts Component */}
//       <div className="w-full">
//         <ErrorBoundary>
//           <Accounts configModalClosed={configModalClosed} />
//         </ErrorBoundary>
//       </div>

//       {/* Dashboard Content */}
//       <div className="flex w-full">
//         <div className="w-[58%] flex-shrink-0 -mt-4 h-full">
//           <ErrorBoundary>
//             <Emails
//               emails={emails}
//               activeCategory={activeCategory}
//               loading={loading}
//               error={error}
//               currentPage={currentPage}
//               setCurrentPage={setCurrentPage}
//               emailsPerPage={emailsPerPage}
//               onEmailSelect={onEmailSelect}
//               onCategoryChange={handleCategoryChange}
//               onFetchEmails={(forceRefresh) =>
//                 fetchEmails(currentPage, activeCategory, forceRefresh)
//               }
//               onDelete={deleteEmail}
//               viewingAllAccounts={viewingAllAccounts}
//               progress={progress}
//             />
//           </ErrorBoundary>
//         </div>

//         {/* Right column - Todo List & Upcoming Events */}
//         <div className="w-[40%] flex gap-4 flex-shrink-0">
//           <ErrorBoundary>
//             <Meetings />
//             <TodoList />
//           </ErrorBoundary>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DashboardContent;

// DashboardContent.jsx
import React, { useEffect } from "react";
import Emails from "./Emails";
import Meetings from "./Meetings";
import TodoList from "./TodoList";
import Accounts from "./Accounts";
import { useEmails } from "../../providers/EmailsContext";
import { useMeetings } from "../../providers/MeetingsContext"; // Import meetings context
import { ErrorBoundary } from "./ErrorBoundary";
import { useAuth } from "../../providers/AuthContext";

const UpcomingEventCard = ({ nextMeeting, loadingMeeting }) => {
  // Format meeting time in 12-hour format with AM/PM
  const formatMeetingTime = (dateTime) => {
    if (!dateTime) return "";
    try {
      const date = new Date(dateTime);
      if (isNaN(date.getTime())) return "";
      return date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
      });
    } catch (err) {
      console.error("Error formatting meeting time:", err);
      return "";
    }
  };

  // Helper function to extract the meeting link
  const getMeetingLink = (meeting) => {
    if (!meeting) return null;

    // Check for hangoutLink first (Google Meet direct link)
    if (meeting.hangoutLink) {
      return meeting.hangoutLink;
    }

    // Check for conferenceData with entryPoints (Google Meet standard format)
    if (
      meeting.conferenceData &&
      Array.isArray(meeting.conferenceData.entryPoints)
    ) {
      // Find video entry point
      const videoEntry = meeting.conferenceData.entryPoints.find(
        (entry) => entry.entryPointType === "video"
      );
      if (videoEntry && videoEntry.uri) {
        return videoEntry.uri;
      }

      // If no video entry found, use the first entry point
      if (
        meeting.conferenceData.entryPoints.length > 0 &&
        meeting.conferenceData.entryPoints[0].uri
      ) {
        return meeting.conferenceData.entryPoints[0].uri;
      }
    }

    // Check for conferenceData with direct link property
    if (meeting.conferenceData && meeting.conferenceData.link) {
      return meeting.conferenceData.link;
    }

    // Check for any URI in the conferenceData object
    if (meeting.conferenceData && meeting.conferenceData.uri) {
      return meeting.conferenceData.uri;
    }

    // Check if there's a location that looks like a URL (Zoom, Teams, etc.)
    if (meeting.location) {
      const locationStr = meeting.location.toLowerCase();
      if (
        locationStr.includes("http") ||
        locationStr.includes("zoom") ||
        locationStr.includes("teams") ||
        locationStr.includes("meet.google")
      ) {
        // Try to extract URL from location
        const urlMatch = meeting.location.match(/(https?:\/\/[^\s]+)/g);
        if (urlMatch && urlMatch[0]) {
          return urlMatch[0];
        }
        return meeting.location;
      }
    }

    // No meeting link found
    return null;
  };

  const meetingLink = nextMeeting ? getMeetingLink(nextMeeting) : null;

  return (
    <div className="relative bg-[#001D47] m-auto p-4 mb-2 w-[96%] rounded-md overflow-hidden min-h-[200px]">
      <div className="absolute bg-gradient-to-r from-[#00419E] to-[#001D47] w-[170px] h-[170px] bottom-[-20%] right-[-2%] z-0 rounded-full"></div>

      {/* Content wrapper with relative positioning and higher z-index */}
      <div className="relative z-10">
        <div className="p-2 flex items-center">
          <div className="text-white font-bold text-xl flex-grow">
            Upcoming Events
          </div>
        </div>

        {loadingMeeting ? (
          <div className="p-2 text-white text-xs flex items-center justify-center h-16">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white"></div>
          </div>
        ) : nextMeeting ? (
          <div className="px-2">
            <div className="text-white text-lg font-medium mb-2">
              {nextMeeting.summary || "Untitled Meeting"}
            </div>

            {nextMeeting.location && (
              <div className="text-white text-sm mb-2">
                <span className="opacity-80">Location:</span>{" "}
                {nextMeeting.location}
              </div>
            )}

            {nextMeeting.attendees && nextMeeting.attendees.length > 0 && (
              <div className="text-white text-sm mb-2">
                <span className="opacity-80">Attendees:</span>{" "}
                {nextMeeting.attendees.length}
              </div>
            )}

            <div className="flex items-center justify-between mt-4">
              <div className="text-white font-semibold flex items-center">
                <svg
                  className="h-5 w-5 mr-2 opacity-80"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                {nextMeeting.start && nextMeeting.end
                  ? `${formatMeetingTime(
                      nextMeeting.start.dateTime || nextMeeting.start.date
                    )} to ${formatMeetingTime(
                      nextMeeting.end.dateTime || nextMeeting.end.date
                    )}`
                  : "Time not specified"}
              </div>
              <div className="flex items-center">
                {meetingLink ? (
                  <a
                    href={meetingLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="py-2 px-4 text-blue-600 bg-white font-medium rounded-md border-0 inline-flex items-center hover:bg-opacity-90 hover:shadow-md transition-all duration-200"
                  >
                    <svg
                      className="h-4 w-4 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 002 2z"
                      />
                    </svg>
                    Join Meeting
                  </a>
                ) : (
                  <div className="py-2 px-4 text-blue-300 bg-white bg-opacity-50 font-medium rounded-md border-0 inline-flex items-center cursor-not-allowed">
                    <svg
                      className="h-4 w-4 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                    No Link Available
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-2 text-white">
            <svg
              className="h-12 w-12 mb-3 opacity-80"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <p className="text-lg font-medium">No upcoming meetings</p>
            <p className="text-sm opacity-80 mt-1">
              Your schedule is clear for today
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

const DashboardContent = ({ onEmailSelect, configModalClosed }) => {
  const [nextMeeting, setNextMeeting] = React.useState(null);

  // Get meetings and loading state from context
  const { meetings, loading: meetingsLoading } = useMeetings();

  const {
    emails,
    loading,
    error,
    activeCategory,
    currentPage,
    setCurrentPage,
    viewingAllAccounts,
    fetchEmails,
    handleCategoryChange,
    deleteEmail,
    emailsPerPage,
    progress,
  } = useEmails();

  console.log("The emails are ", emails);

  const { fetchUserData } = useAuth();

  // Function to find the next upcoming meeting
  const findNextMeeting = React.useCallback((meetingsList) => {
    if (!meetingsList || meetingsList.length === 0) {
      return null;
    }

    const now = new Date();
    const upcomingMeetings = meetingsList
      .filter((meeting) => {
        if (!meeting.start?.dateTime && !meeting.start?.date) return false;
        const meetingTime = new Date(
          meeting.start.dateTime || meeting.start.date
        );
        return meetingTime > now;
      })
      .sort((a, b) => {
        const aTime = a.start?.dateTime || a.start?.date || "";
        const bTime = b.start?.dateTime || b.start?.date || "";
        return new Date(aTime) - new Date(bTime);
      });

    return upcomingMeetings.length > 0 ? upcomingMeetings[0] : null;
  }, []);

  // Update next meeting when meetings change
  React.useEffect(() => {
    console.log(
      "📅 Dashboard: Meetings from context updated:",
      meetings.length
    );
    const nextUpcomingMeeting = findNextMeeting(meetings);
    setNextMeeting(nextUpcomingMeeting);

    if (nextUpcomingMeeting) {
      console.log(
        "📅 Dashboard: Next meeting set:",
        nextUpcomingMeeting.summary
      );
    } else {
      console.log("📅 Dashboard: No upcoming meetings found");
    }
  }, [meetings, findNextMeeting]);

  // Also listen for the custom events as a backup
  React.useEffect(() => {
    const handleMeetingsUpdate = (event) => {
      console.log("📅 Dashboard: Custom event received:", event.detail);
      if (event.detail && Array.isArray(event.detail.meetings)) {
        const eventMeetings = event.detail.meetings;
        const nextUpcomingMeeting = findNextMeeting(eventMeetings);

        // Only update if we don't already have this meeting or if it's different
        if (nextUpcomingMeeting && nextUpcomingMeeting.id !== nextMeeting?.id) {
          setNextMeeting(nextUpcomingMeeting);
          console.log(
            "📅 Dashboard: Next meeting updated via event:",
            nextUpcomingMeeting.summary
          );
        }
      }
    };

    // Add event listener for meetings updates
    window.addEventListener("meetings_updated", handleMeetingsUpdate);

    return () => {
      window.removeEventListener("meetings_updated", handleMeetingsUpdate);
    };
  }, [findNextMeeting, nextMeeting?.id]);

  useEffect(() => {
    fetchUserData();
  }, []);

  React.useEffect(() => {
    const cachedEmails = localStorage.getItem("cached_emails");
    if (!cachedEmails) {
      fetchEmails(1, "all", true);
    }
  }, []);

  return (
    <div className="p-4 sm:p-6 flex flex-col h-full overflow-y-auto">
      {/* Upcoming Events Card */}
      <UpcomingEventCard
        nextMeeting={nextMeeting}
        loadingMeeting={meetingsLoading}
      />

      {/* Accounts Component */}
      <div className="w-full">
        <ErrorBoundary>
          <Accounts configModalClosed={configModalClosed} />
        </ErrorBoundary>
      </div>

      {/* Dashboard Content */}
      <div className="flex w-full">
        <div className="w-[58%] flex-shrink-0 -mt-4 h-full">
          <ErrorBoundary>
            <Emails
              emails={emails}
              activeCategory={activeCategory}
              loading={loading}
              error={error}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              emailsPerPage={emailsPerPage}
              onEmailSelect={onEmailSelect}
              onCategoryChange={handleCategoryChange}
              onFetchEmails={(forceRefresh) =>
                fetchEmails(currentPage, activeCategory, forceRefresh)
              }
              onDelete={deleteEmail}
              viewingAllAccounts={viewingAllAccounts}
              progress={progress}
            />
          </ErrorBoundary>
        </div>

        {/* Right column - Todo List & Upcoming Events */}
        <div className="w-[40%] flex gap-4 flex-shrink-0">
          <ErrorBoundary>
            <Meetings />
            <TodoList />
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
};

export default DashboardContent;
